import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { ShowcaseCategoryUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ShowcaseCategoryUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  code: string;
  codeSelectedValue?: { displayId: string; id: string } | null;
  onCodeChange?: (value: string) => void;
  codeError?: string;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  showcaseCategoryUpdateStore: ShowcaseCategoryUpdateStore;
};

export const ShowcaseCategoryUpdateForm: React.FC<ShowcaseCategoryUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      code = "",
      codeError,
      onCodeChange = () => {},
      name = "",
      nameError,
      onNameChange = () => {},
      showcaseCategoryUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="ShowcaseCategory"
              mode="update"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "code":
                    onCodeChange?.(valor);
                    break;
                  case "name":
                    onNameChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={showcaseCategoryUpdateStore.getCardErrors("null")}
              title={langStore.groupShowcaseCategoryLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={code}
                  error={Boolean(codeError)}
                  warning={
                    !codeError &&
                    Boolean(showcaseCategoryUpdateStore.warnings["code"])
                  }
                  helperText={
                    codeError ||
                    showcaseCategoryUpdateStore.warnings["code"]?.message
                  }
                  label={langStore.ShowcaseCategoryCodeLabel}
                  onChange={(value: string) => onCodeChange(value)}
                />
                <InputString
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(showcaseCategoryUpdateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    showcaseCategoryUpdateStore.warnings["name"]?.message
                  }
                  label={langStore.ShowcaseCategoryNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
